import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
}))
